(() => {
  if (customElements.get('panorama-delivery-estimate')) return;
  const dayMilliseconds = 86400000;
  const holidaysByYear = new Map();
  const iso = date => date.toISOString().slice(0, 10);

  class PanoramaDeliveryEstimate extends HTMLElement {
    static orderDate(now = new Date()) {
      const parts = new Intl.DateTimeFormat('en-US', {timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(now);
      const value = type => Number(parts.find(part => part.type === type).value);
      return new Date(Date.UTC(value('year'), value('month') - 1, value('day'), 12));
    }

    static orthodoxEaster(year) {
      const a = year % 4;
      const b = year % 7;
      const c = year % 19;
      const d = (19 * c + 15) % 30;
      const e = (2 * a + 4 * b - d + 34) % 7;
      const month = Math.floor((d + e + 114) / 31);
      const day = (d + e + 114) % 31 + 1;
      const calendarOffset = Math.floor(year / 100) - Math.floor(year / 400) - 2;
      return new Date(Date.UTC(year, month - 1, day + calendarOffset, 12));
    }

    static holidays(year) {
      if (holidaysByYear.has(year)) return holidaysByYear.get(year);
      const fixed = ['01-01', '01-02', '01-06', '01-07', '01-24', '05-01', '06-01', '08-15', '11-30', '12-01', '12-25', '12-26'];
      const dates = new Set(fixed.map(day => `${year}-${day}`));
      const easter = this.orthodoxEaster(year);
      for (const offset of [-2, 0, 1, 49, 50]) dates.add(iso(new Date(easter.getTime() + offset * dayMilliseconds)));
      holidaysByYear.set(year, dates);
      return dates;
    }

    static isBusinessDay(date) {
      const weekday = date.getUTCDay();
      return weekday !== 0 && weekday !== 6 && !this.holidays(date.getUTCFullYear()).has(iso(date));
    }

    static addBusinessDays(orderDate, days) {
      const date = new Date(orderDate.getTime());
      let remaining = days;
      while (remaining > 0) {
        date.setUTCDate(date.getUTCDate() + 1);
        if (this.isBusinessDay(date)) remaining -= 1;
      }
      return date;
    }

    static deliveryWindow(now, minDays = 6, maxDays = 7) {
      const date = this.orderDate(now);
      return {start: this.addBusinessDays(date, minDays), end: this.addBusinessDays(date, maxDays)};
    }

    connectedCallback() {
      this.refresh = () => {
        if (document.visibilityState !== 'hidden') this.renderEstimate();
      };
      this.renderEstimate();
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
      this.timer = window.setInterval(this.refresh, 60000);
    }

    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
      window.clearInterval(this.timer);
    }

    renderEstimate() {
      const today = iso(PanoramaDeliveryEstimate.orderDate());
      if (this.renderedDate === today) return;
      const startElement = this.querySelector('[data-delivery-start]');
      const endElement = this.querySelector('[data-delivery-end]');
      const windowElement = this.querySelector('[data-delivery-window]');
      if (!startElement || !endElement || !windowElement) return;
      const minDays = Number(this.dataset.minDays);
      const maxDays = Number(this.dataset.maxDays);
      if (!Number.isInteger(minDays) || !Number.isInteger(maxDays) || minDays < 1 || maxDays < minDays || maxDays > 60) return;
      const {start, end} = PanoramaDeliveryEstimate.deliveryWindow(new Date(), minDays, maxDays);
      const locale = this.dataset.locale || 'ro-RO';
      const sameMonth = start.getUTCFullYear() === end.getUTCFullYear() && start.getUTCMonth() === end.getUTCMonth();
      const startFormat = new Intl.DateTimeFormat(locale, {timeZone: 'UTC', day: 'numeric', ...(sameMonth ? {} : {month: 'long', year: 'numeric'})});
      const endFormat = new Intl.DateTimeFormat(locale, {timeZone: 'UTC', day: 'numeric', month: 'long', year: 'numeric'});
      startElement.dateTime = iso(start);
      endElement.dateTime = iso(end);
      startElement.textContent = startFormat.format(start);
      endElement.textContent = endFormat.format(end);
      windowElement.hidden = false;
      this.renderedDate = today;
    }
  }

  customElements.define('panorama-delivery-estimate', PanoramaDeliveryEstimate);
})();
